<template>
    <v-container fluid>
        <v-row v-if="contractEdit == false">
            <v-col cols="12">
                <v-card flat outlined>
                    <v-card-title>
                        <v-row dense>
                            <v-col>{{ $t('labels.issuedContracts') }}</v-col>
                            <v-col
                                class="text-right"
                                v-if="placement.placement_status_id == 9 && $myStore.state.user.user_role_id == 1"
                            >
                                <v-btn class="ml-2 mr-2" color="secondary" @click="determineAllContractsVerification()">
                                    <v-icon small>fa-trash</v-icon>&nbsp;{{ $t('buttons.determineAllContracts') }}
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <TheTable
                                    :additional-filters="itemsTable.additionalFilters"
                                    :default-sort="itemsTable.defaultSort"
                                    :fields="itemsTable.headers"
                                    :height="itemsTable.height"
                                    :total-records="itemsTable.total"
                                    @excel="excelExport"
                                    @headers="selectHeaders"
                                    @reload="reloadData"
                                >
                                    <tr
                                        v-for="(item, key) in itemsTable.items"
                                        :key="key"
                                        :class="{'cursor-pointer': true}"
                                    >
                                        <td
                                            v-if="itemsTable.selectedHeaders.includes('id')"
                                            class="font-weight-bold"
                                            @click="editClick(item, false)"
                                        >
                                            {{ item.id }}
                                        </td>
                                        <td @click="openSeafarerActivity()">
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{on, attrs}">
                                                    <v-chip
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        v-show="item.contract_status_id == 1"
                                                        class="text-uppercase pl-4"
                                                        text-color="#008000"
                                                        color="#00800040"
                                                        >{{ item.status_display }}</v-chip
                                                    >
                                                    <v-chip
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        v-show="item.contract_status_id == 2"
                                                        class="text-uppercase pl-4"
                                                        text-color="#BBBB00"
                                                        color="#E1E10040"
                                                        >{{ item.status_display }}</v-chip
                                                    >
                                                    <v-chip
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        v-show="item.contract_status_id == 3"
                                                        class="text-uppercase pl-4"
                                                        text-color="#6F6F6F"
                                                        color="#6F6F6F40"
                                                        >{{ item.status_display }}</v-chip
                                                    >
                                                    <v-chip
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        v-show="item.contract_status_id == 4"
                                                        class="text-uppercase pl-4"
                                                        text-color="#FF0000"
                                                        color="#FF000040"
                                                        >{{ item.status_display }}</v-chip
                                                    >
                                                    <v-chip
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        v-show="item.contract_status_id == 5"
                                                        class="text-uppercase pl-4"
                                                        text-color="#4360DF"
                                                        color="#4360DF40"
                                                        >{{ item.status_display }}</v-chip
                                                    >
                                                </template>
                                                <span> {{ $t('tooltips.openSeafarerActivity') }}</span>
                                            </v-tooltip>
                                        </td>
                                        <td class="font-weight-bold" @click="editClick(item, false)">
                                            {{ item.effective_from_display }}
                                        </td>
                                        <td @click="editClick(item, false)">
                                            {{ item.effective_to_display }}
                                        </td>

                                        <td @click="editClick(item, false)">
                                            {{ item.rank_display }}
                                        </td>
                                        <td @click="editClick(item, false)" class="text-center">
                                            {{ item.properties.seniority }}
                                        </td>
                                        <td @click="editClick(item, false)">
                                            {{ item.entity_display }}
                                        </td>
                                        <td @click="editClick(item, false)">
                                            {{ item.placement_id }}
                                        </td>

                                        <td @click="editClick(item, false)">
                                            {{ item.date_created }}
                                        </td>
                                        <td @click="editClick(item, false)">
                                            {{ item.issued_by }}
                                        </td>
                                    </tr>
                                </TheTable>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" v-if="!placement.gdpr_edit_lock">
                <v-row dense>
                    <v-col cols="3">
                        <Dropdown v-model="contractType" :ajax="true" :data="'contract-types'"></Dropdown>
                    </v-col>
                    <v-col cols="2">
                        <v-btn class="ml-2 mr-2" color="primary" @click="newContract(null)">
                            <v-icon small>fa-plus</v-icon>&nbsp;{{ $t('buttons.newContract') }}
                        </v-btn>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <PlacementSeaContract
                    @edit="editEmit"
                    @edit-remove="removeEditEmit"
                    :inEditMode="inEditMode"
                    @close-edit="removeEdit"
                    :currentContract="currentContract"
                    :contractEdit="contractEdit"
                    :placement="placement"
                ></PlacementSeaContract>
            </v-col>
            <v-col cols="12">
                <PlacementNorwegianContractVue
                    @edit="editEmit"
                    @edit-remove="removeEditEmit"
                    :inEditMode="inEditMode"
                    @close-edit="removeEdit"
                    :currentContract="currentContract"
                    :contractEdit="contractEdit"
                    :placement="placement"
                ></PlacementNorwegianContractVue>
            </v-col>
            <v-col cols="12">
                <PlacementBahriContract
                    @edit="editEmit"
                    @edit-remove="removeEditEmit"
                    :inEditMode="inEditMode"
                    @close-edit="removeEdit"
                    :currentContract="currentContract"
                    :contractEdit="contractEdit"
                    :placement="placement"
                ></PlacementBahriContract>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-dialog v-model="showOtpModal" width="auto" :max-width="400">
                    <v-card class="py-8 px-6 text-center mx-auto ma-4" elevation="12">
                        <h3 class="text-h6 mb-4">{{ $t('labels.verifyContractDetermination') }}</h3>

                        <div class="text-body-2">
                            Paste the code <b>{{ otp }}</b> below.
                        </div>

                        <v-otp-input v-model="enteredOtp" :length="4"></v-otp-input>

                        <v-btn
                            class="my-4"
                            color="primary"
                            width="70%"
                            @click="determineAlContractsExe()"
                            :disabled="verifyingContractIsActive"
                            :loading="determiningContracts"
                            >Verify</v-btn
                        >
                        <div class="text-caption">
                            Don't see the code?
                            <a href="#" style="text-decoration: none" @click.prevent="generateOtp()">Regenerate code</a>
                        </div>
                    </v-card>
                </v-dialog>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import Dropdown from './trinkets/Dropdown.vue';
import TheTable from './trinkets/TheTable';
import PlacementSeaContract from './PlacementSeaContract.vue';
import Contract from '../models/Contract';
import PlacementNorwegianContractVue from './PlacementNorwegianContract.vue';
import PlacementBahriContract from './PlacementBahriContract.vue';

export default {
    name: 'PlacementContracts',
    components: {TheTable, Dropdown, PlacementSeaContract, PlacementNorwegianContractVue, PlacementBahriContract},
    props: ['placement', 'inEditMode'],
    data: function () {
        return {
            currentContract: new Contract({}),
            enteredOtp: '',
            showOtpModal: false,
            otp: null,
            determiningContracts: false,
            itemsTable: {
                selectedHeaders: [],

                headers: [
                    {text: this.$t('fields.contractId'), value: 'id', type: '', allowFilter: false, sortable: false},
                    {
                        text: this.$t('fields.status'),
                        value: 'status',
                        type: '',
                        allowFilter: false,
                        sortable: false,
                    },
                    {
                        text: this.$t('fields.effectiveFrom'),
                        value: 'effective_from',
                        type: '',
                        allowFilter: false,
                        sortable: false,
                    },
                    {
                        text: this.$t('fields.effectiveTo'),
                        value: 'effective_to',
                        type: '',
                        allowFilter: false,
                        sortable: false,
                    },

                    {
                        text: this.$t('fields.rank'),
                        value: 'rank',
                        type: '',
                        allowFilter: false,
                        sortable: false,
                    },
                    {
                        text: this.$t('fields.seniority'),
                        value: 'seniority',
                        type: '',
                        allowFilter: false,
                        sortable: false,
                    },
                    {
                        text: this.$t('fields.entity'),
                        value: 'entity',
                        type: '',
                        allowFilter: false,
                        sortable: false,
                    },
                    {
                        text: this.$t('fields.placementId'),
                        value: 'placement_id',
                        type: '',
                        allowFilter: false,
                        sortable: false,
                    },

                    {
                        text: this.$t('fields.dateCreated'),
                        value: 'date_created',
                        type: '',
                        allowFilter: false,
                        sortable: false,
                    },
                    {
                        text: this.$t('fields.issuedBy'),
                        value: 'issued_by',
                        type: '',
                        allowFilter: false,
                        sortable: false,
                    },
                ],
                items: [],
                total: 0,
                lastRequest: null,
                height: '0px',
                defaultSort: {
                    field: 'id',
                    descending: true,
                },
            },
            contractEdit: false,
            contractID: null,
            contractType: null,
        };
    },
    computed: {
        verifyingContractIsActive() {
            return this.enteredOtp.length !== 4;
        },
        bankDropdownCols() {
            return this.windowWidth <= 1636 ? 12 : 9;
        },
    },
    methods: {
        openSeafarerActivity() {
            if (this.$myStore.state.user.user_role_id == 1) {
                this.$myStore.commit('setOpenActivity', true);
                this.$nextTick(() => {
                    this.$router.push('/seafarers/' + this.placement.seafarer_id);
                });
            }
        },
        determineAlContractsExe() {
            let success = true;

            if (this.enteredOtp !== null) {
                if (this.otp != this.enteredOtp) {
                    success = false;
                    this.$alert(this.$t('alerts.codeIsInvalid'));
                }
            } else {
                success = false;
                this.$alert(this.$t('alerts.codeIsNotEntered'));
            }

            if (success) {
                let vm = this;
                this.determiningContracts = true;
                this.$APICall('post', 'determine-all-contract-on-placement/' + this.placement.id, {}, (success) => {
                    if (success) {
                        vm.$alert(vm.$t('alerts.allContractDetermined'));
                        vm.reloadData();
                        vm.$emit('reload');
                    } else {
                        vm.$alert(vm.$t('alerts.basicError'));
                    }
                    vm.determiningContracts = false;
                });
                vm.showOtpModal = false;
            }
        },
        determineAllContractsVerification() {
            this.$verify(this.$t('alerts.determineAllContractsOnPlacement'), (result) => {
                if (result) {
                    this.enteredOtp = '';
                    this.generateOtp();
                    this.showOtpModal = true;
                } else {
                    this.showOtpModal = false;
                }
            });
        },
        generateOtp() {
            const randomNum = Math.random() * 9000;
            this.otp = Math.floor(1000 + randomNum);
        },
        removeEditEmit() {
            this.$emit('remove-edit');
        },
        editEmit() {
            this.$emit('edit');
        },
        removeEdit() {
            this.currentContract = new Contract({});
            this.contractEdit = false;
            this.reloadData();
        },
        editClick(item) {
            let vm = this;
            this.$APICall('get', 'contracts/' + item.id, {}, (data, succes) => {
                if (succes) {
                    vm.contractEdit = true;
                    vm.currentContract = data.contract;
                    vm.currentContract.properties = JSON.parse(JSON.stringify(data.contract.properties));
                }
            });
        },
        selectHeaders(headers) {
            this.itemsTable.selectedHeaders = headers;
        },
        newContract() {
            let vm = this;
            if (this.placement.placement_status_id == 7 || this.placement.placement_status_id == 8) {
                this.$alert(vm.$t('alerts.cannotCreateContractOnThisPlacement'));
            } else if (this.placement.placement_status_id != 2 && this.placement.placement_status_id != 9) {
                this.$alert(vm.$t('alerts.placementNotInPLanned'));
            } else if (this.placement.seniority == null) {
                this.$alert(vm.$t('alerts.defineSeniorityForThisPlacement'));
            } else {
                if (this.contractType == null) {
                    this.$alert(vm.$t('alerts.selectContractType'));
                } else {
                    let contractType = this.contractType;
                    let userId = this.$myStore.state.user.id;
                    this.$APICall('get', 'wage-template-info/' + this.placement.id, {}, (data, success) => {
                        if (success) {
                            if (data.response_message == 1) {
                                vm.$APICall(
                                    'post',
                                    'create-contracts/' + vm.placement.id,
                                    {contractType, userId},
                                    (data, success) => {
                                        if (success) {
                                            vm.contractEdit = true;
                                            vm.currentContract = data.contract;
                                            vm.currentContract.properties = JSON.parse(data.contract.properties);
                                        }
                                    },
                                );
                            } else {
                                vm.$alert(
                                    vm.$t('alerts.defineWageTemplateForRankAndSeniority') +
                                        ' <a  target="_blank" href="#/maritime-objects/' +
                                        this.placement.maritime_object_id +
                                        '">Maritime object!</a>',
                                );
                            }
                        }
                    });
                }
            }
        },
        reloadData(request) {
            this.lastRequest = request;
            let vm = this;
            this.$APICall(
                'get',
                'placement-contracts/' + this.placement.id,
                request,
                (data, success) => {
                    if (success) {
                        vm.$nextTick(() => {
                            vm.itemsTable.itemss = [];
                            vm.itemsTable.items = data.items;
                            vm.itemsTable.total = data.total;
                        });
                    } else {
                        vm.$alert(vm.$t('alerts.basicError'));
                    }
                },
                false,
            );
        },
        excelExport() {
            let excelRequest = JSON.parse(JSON.stringify(this.lastRequest));
            excelRequest.pagination.itemsPerPage = 999999999;
            excelRequest.pagination.page = 1;

            let vm = this;
            this.$APICall(
                'get',
                'items',
                excelRequest,
                (data, success) => {
                    if (success) {
                        vm.$APICall('post', 'excel/contracts', data.items, (data) => {
                            window.open(data.link);
                        });
                    } else {
                        vm.$alert(vm.$t('alerts.basicError'));
                    }
                },
                false,
            );
        },
        resolveWindowResize() {
            this.itemsTable.height = window.innerHeight - 510 + 'px';
        },
    },
    mounted() {
        if (!this.$myStore.state.loggedIn) {
            this.$router.replace('login');
        }

        window.addEventListener('resize', this.resolveWindowResize);
        this.resolveWindowResize();
    },
};
</script>

<style scoped></style>
